<template>
  <div>
    <b-container
      fluid
      class="mt-4"
    >
      <property-details />
    </b-container>
  </div>
</template>

<script>
    import PropertyDetails from "../components/PropertyDetails/PropertyDetails";

    export default {
        name: "PropertyDetailsPage",
        components: {PropertyDetails},
    };
</script>
